module.exports = __webpack_public_path__ + "static/media/orange-location.6fc2a9b4.svg";